// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import './analytics/analytics'
import Dropzone from 'dropzone'
import 'jquery-ui';
import 'jquery-ui/ui/widgets/datepicker';

import swal from 'sweetalert';

import 'dropzone/dist/dropzone.css'
import './tab_overflow'
import './select2'
import './popover'
import './profile_details'
import './service_details'
import './products_n_services'
import './certificates_n_awards'
import './sign_in'
import './registration/sign_up'
import './registration/new_company_details'
import './registration/choose_company'
import './reset_password'
import './new_password'
import './contact_us'
import './deals/sku_cards'
import './deals/deal'
import './products/index'
import './deals/supplier/live_deals'
import './my_company/show'
import './companies/show'
import './credit_cards/create'
import './account_setting'
import './admin/index'
import './admin/matching'
import './admin/companies'
import './welcome/resend_email_verification'
import './device_warning'
import './live_search'
import './app_notifications'
import './connections'
import './matches'
import './personal_detail'
import './company_detail'
import './tagify'
import './connection_recommendation'
import './admin/buyer/add_buyer'
import './admin/companies/add_member'
import './user/edit_member'
import './user/add_teams'
import './user/create_user'
import './team/create_team'
import './team/edit_team'
import './team/team'
import './catalog'
import './conversations'
import './conversation_preview'
import './supply_tasks/create_supply_task_requests'
import './deal_sample_request/create_deal_sample_request'
import './deal_sample_request/update_deal_sample_request'
import './deal_information_request/create_deal_information_request'
import './deal_information_request/update_deal_information_request'
import './deal_pricing_request/create_deal_pricing_request'
import './deal_pricing_request/entry_deal_pricing_request_proposals'
import './deal_pricing_request/pricing_comparison'
import './deals/intake'
import './sectors_n_tags'
import './ratings/rating'
import './sendbird_conversation'
import './choose_workspace'
import './choose_sectors'
import './connect_sectors'
import './choose_tags'
import './company_info'
import './flash'
import './back_button'
import './team_select'
import './ai_matches'
import './admin/ai_matches_chart'
import './landing_page/landing_page'
import './landing_page/testimonials'
import './landing_page/partnerships'
import './deal_skus'
import './insights/insight'
import './company_notes'
import './deal_response'
import './message_templates/message_template'

import 'channels'

require("@rails/ujs").start()
// require("turbolinks").start()
require("@rails/activestorage").start()
require("@nathanvda/cocoon")
require("dropzone")
require("lightslider")
require("trix")
require("@rails/actiontext")

window.$ = window.jQuery = $; // Ensure jQuery is available globally

Dropzone.autoDiscover = false;

window.swal = swal;

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)


$(() => {
    // Auto dismiss message after 10 seconds
    setTimeout(() => {
        $("#flash-wrapper").slideUp(500);
    }, 10000);
});

window.FlashNotice = {
    show() {
        $("#flash-wrapper").show();
        setTimeout(() => {
            $("#flash-wrapper").slideUp(500);
        }, 10000)
    }
}

$('#sidebar-toggle').on('click', function () {
    $('.sidebar, .sidebar-toggle, .sidebar *').toggleClass('closed');

    if ($('.sidebar-toggle').hasClass('closed')) {
        $('#sidebar-toggle i').removeClass('fa-arrow-left').addClass('fa-arrow-right');
    } else {
        $('#sidebar-toggle i').removeClass('fa-arrow-right').addClass('fa-arrow-left');
    }

    $('.navbar-content-wrapper').toggleClass('closed-left');
    $('.navbar-content-wrapper').toggleClass('open-left');
    $('.page-content-wrapper').toggleClass('closed-left');
    $('.page-content-wrapper').toggleClass('open-left');
});

document.addEventListener('DOMContentLoaded', function () {
    var favicon = document.getElementById('favicon');
    var darkModeFaviconPath = favicon.dataset.darkModeFavicon;
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
        favicon.href = darkModeFaviconPath;
    }

    const pageContentWrapper = document.querySelector('.page-content-wrapper');
    const sidebar = document.querySelector('.sidebar');

    if (pageContentWrapper) {
        pageContentWrapper.classList.add('ready');
    }

    if (sidebar && pageContentWrapper) {
        pageContentWrapper.classList.add('open-left');
        pageContentWrapper.classList.remove('closed-left');
    } else if (pageContentWrapper) {
        pageContentWrapper.classList.remove('open-left');
        pageContentWrapper.classList.add('closed-left');
    }
});

window.addEventListener('load', setHeaderOffset);
$(window).on("resize", function () {
    setHeaderOffset();
});

function setHeaderOffset() {
    const header = document.querySelector('.h100');
    if (!header) return;
    document.documentElement.style.setProperty('--header-h', `${header.offsetHeight}px`);
}


document.addEventListener('analyticsReady', () => {
    const logoutLinks = document.querySelectorAll('a[href="/users/sign_out"]');
    logoutLinks.forEach((link) => {
        link.addEventListener("click", function (event) {
            analytics.reset();
        });
    });

    const impersonateUserLinks = document.querySelectorAll('a[href^="/switch_user"]');
    impersonateUserLinks.forEach((link) => {
        link.addEventListener("click", function (event) {
            const url = new URL(link.href);
            analytics.track(ANALYTICS_EVENTS.USER_IMPERSONATED, {
                impersonating_user_id: current_user_uuid,
                company_id_impersonated: url.searchParams.get('company_id'),
                company_name_impersonated: url.searchParams.get('company_name'),
                user_id_impersonated: url.searchParams.get('user_id'),
                url: window.location.href,
            })
        });
    });
});
